import {RobotModel} from "../GameObjects/Assembly/RobotModel";
import {PuzzleModel} from "../GameObjects/Puzzle/PuzzleModel";
import {StateName} from "./StateName";
import {MusicModel} from "../GameObjects/Music/MusicModel";
import {CookingModel} from "../GameObjects/Cooking/CookingModel";
import {MonsterModel} from "../GameObjects/Assembly/MonsterModel";

export enum ItemType {
    Robot = "robot",
    Monster = "monster",
    Puzzle = "puzzle",
    Glockenspiel = "glockenspiel",
    Durian = "durian",
    Pasta = "pasta",
    Delight = "delight",
    Coconut = "coconut",
    Movie = "movie",
    Nyatiti = "nyatiti",
    Didgeridoo = "didgeridoo",
    Bagpipes = "bagpipes",
}

export const ItemTypes = [
    ItemType.Robot,
    ItemType.Monster,
    ItemType.Puzzle,
    ItemType.Glockenspiel,
    ItemType.Durian,
    ItemType.Pasta,
    ItemType.Delight,
    ItemType.Coconut,
    ItemType.Movie,
    ItemType.Nyatiti,
    ItemType.Didgeridoo,
    ItemType.Bagpipes,
];

export enum Country {
    Japan = "japan",
    Iceland = "iceland",
    China = "china",
    Germany = "germany",
    Thailand = "thailand",
    Italy = "italy",
    Turkey = "turkey",
    Polynesia = "polynesia",
    France = "france",
    Kenya = "kenya",
    Australia = "australia",
    Scotland = "scotland",
    Argentina = "argentina",
    Switzerland = "switzerland",
    Mexico = "mexico",
    Russia = "russia",
    Egypt = "egypt",
    Alaska = "alaska",
    Ghana = "ghana",
    Unknown = "unknown"
}

export enum Character {
    Leo = "leo",
    Andy = "andy",
    Carmen = "carmen",
    Luna = "luna",
}

export type ItemData = RobotModel | MonsterModel | PuzzleModel | MusicModel | CookingModel;

export interface ItemModel {
    readonly itemType: ItemType;
    readonly itemData: ItemData;
}

export interface PostcardModel {
    readonly country: Country;
}

export interface PackageModel extends ItemModel, PostcardModel {
    readonly stateName: StateName;
    readonly label?: string;
}